import React from 'react';
import AutolistifyLogo from '../../assets/styles/Autolistify-logo.png';
import { Box, Container, Tabs, Tab, AppBar, Toolbar, IconButton, Badge, Avatar, Menu, MenuItem, Button } from '@mui/material';
import { ShoppingCart, Notifications, Search as SearchIcon, Store, BarChart, VpnKey, Settings, ShoppingBag, ThreeDRotation, CloudUpload, Extension } from '@mui/icons-material';

const Header = ({ activeTab, handleTabClick, setActiveTab, onLogout, currentUser }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTabChange = (event, newValue) => {
    handleTabClick(newValue);
  };

  const handleLogoutClick = () => {
    handleClose();
    if (typeof onLogout === 'function') {
      onLogout();
    }
  };

  const setTab = (tab) => {
    if (typeof setActiveTab === 'function') {
      setActiveTab(tab);
    } else if (typeof handleTabClick === 'function') {
      handleTabClick(tab);
    }
  };

  return (
    <AppBar position="static" color="default" elevation={1} sx={{ bgcolor: 'white' }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 4, minWidth: 120 }}>
            <a href="/" style={{ display: 'flex', alignItems: 'center' }}>
              <img
                src={AutolistifyLogo}
                alt="autolistify logo"
                style={{ height: 100, width: 'auto', display: 'block', borderRadius: 12, marginTop: 8, marginBottom: 8 }}
              />
            </a>
          </Box>

          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end' }}>
            <IconButton size="large" color="inherit">
              <Badge badgeContent={4} color="error">
                <ShoppingCart />
              </Badge>
            </IconButton>
            <IconButton size="large" color="inherit">
              <Badge badgeContent={2} color="error">
                <Notifications />
              </Badge>
            </IconButton>
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <Avatar alt="User" src={currentUser?.photoURL} />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open}
              onClose={handleClose}
            >
              <MenuItem onClick={handleClose}>Profile</MenuItem>
              <MenuItem onClick={handleClose}>My account</MenuItem>
              <MenuItem onClick={handleLogoutClick}>Logout</MenuItem>
            </Menu>
          </Box>
        </Toolbar>

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="main navigation tabs"
            sx={{
              '& .MuiTabs-indicator': {
                backgroundColor: 'primary.main',
              },
            }}
          >
            <Tab
              icon={<Store />}
              iconPosition="start"
              label="Store Connection"
              value="store-connection"
              sx={{ minHeight: 64 }}
            />
            <Tab
              icon={<BarChart />}
              iconPosition="start"
              label="Product Analytics"
              value="product-analytics"
              sx={{ minHeight: 64 }}
            />
            <Tab
              icon={<VpnKey />}
              iconPosition="start"
              label="Keyword Metrics"
              value="keyword-metrics"
              sx={{ minHeight: 64 }}
            />
            <Tab
              icon={<ShoppingBag />}
              iconPosition="start"
              label="Imported Products"
              value="imported-products"
              sx={{ minHeight: 64 }}
            />
            <Tab
              icon={<SearchIcon />}
              iconPosition="start"
              label="Taobao Search"
              value="taobao-search"
              sx={{ minHeight: 64 }}
            />
            <Tab
              icon={<Settings />}
              iconPosition="start"
              label="Settings"
              value="settings"
              sx={{ minHeight: 64 }}
            />
            <Tab
              icon={<CloudUpload />}
              iconPosition="start"
              label="Product Import"
              value="product-import"
              sx={{ minHeight: 64 }}
            />
            <Tab
              icon={<ThreeDRotation />}
              iconPosition="start"
              label="3D Model"
              value="3d-model"
              sx={{ minHeight: 64 }}
            />
            <Tab
              icon={<Extension />}
              iconPosition="start"
              label="Extensions"
              value="extensions"
              sx={{ minHeight: 64 }}
            />
            <Tab
              icon={<Extension />}
              iconPosition="start"
              label="Account"
              value="account"
              sx={{ minHeight: 64 }}
            />
          </Tabs>
          <Button
            color="inherit"
            onClick={() => setTab('extensions')}
            sx={{ color: activeTab === 'extensions' ? '#1976d2' : 'inherit' }}
          >
            Extensions
          </Button>
          <Button
            color="inherit"
            onClick={() => setTab('account')}
            sx={{ color: activeTab === 'account' ? '#1976d2' : 'inherit' }}
          >
            Account
          </Button>
        </Box>
      </Container>
    </AppBar>
  );
};

// Make sure to export the component!
export default Header;